/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ENGAGEMENT_WITH_NGOS_AND_OTHER_EXTERNAL_STAKEHOLDERS',
              'SOCIAL_LABOR_POLICIES_AND_PROCEDURES',
              'RESULTS_OF_SOCIAL_COMPLIANCE_MONITORING',
              'ISSUES_IDENTIFIED_ACTIONS_TAKEN_AND_RESULTS_ACHIEVED_IN_RESPONS',
              'INDIRECT_SUPPLIER_LIST',
              'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST',
              'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST_GLOBAL',
              'NONE_OF_THE_ABOVE',
              'PLEASE_PROVIDE_DETAILS_OF_THE_HOUSING_ARRANGEMENTS_INCLUDING_AT',
              'WHERE_IN_THE_COUNTRY_ARE_THE_DOMESTIC_MIGRANT_WORKERS_FROM_',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    did_the_fac_comm_include_any_of_the_following_select_all_that_a: valueSchema,
  },
}
